import React, { Component } from 'react';
import DangerIcon from '@assets/icons/danger-icon.svg';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import Grid from '@mui/material/Grid2';
import {
  Alert,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TextField,
  Stack,
} from '@mui/material';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';
import StatusFormatter from '../SmartTable/StatusFormatter';
import MapStaticComponent from '~/MapStatic/MapStatic.component';
import StaticMarker from '~/MapStatic/components/StaticMarker';

const COMMENT_AGENT = 0;
const RESET_ROUTE_TASK = 1;
const RejectComments = ({ rejectReason = [] }) => (
  <TableBody>
    {rejectReason.map((rejectReason, index) => (
      <TableRow key={`reject-${index}`}>
        <TableCell>{rejectReason.name}</TableCell>
        <TableCell>{rejectReason.date}</TableCell>
        <TableCell>{rejectReason.dependency}</TableCell>
        <TableCell>{rejectReason.reason}</TableCell>
        <TableCell>{rejectReason.comment}</TableCell>
      </TableRow>
    ))}
  </TableBody>
);

const PauseComments = ({ pauseReason = [] }) => (
  <TableBody>
    {pauseReason.map((pauseReason, index) => (
      <TableRow key={`pause-${index}`}>
        <TableCell>{pauseReason.name}</TableCell>
        <TableCell>{pauseReason.date}</TableCell>
        <TableCell>{pauseReason.dependency}</TableCell>
        <TableCell>{pauseReason.reason}</TableCell>
        <TableCell>{pauseReason.comment}</TableCell>
      </TableRow>
    ))}
  </TableBody>
);

const ModifyStatusComments = ({ modifyReason = [] }) => (
  <TableBody>
    {modifyReason.map((modifyReason, index) => (
      <TableRow key={`modify-${index}`}>
        <TableCell>{modifyReason.name}</TableCell>
        <TableCell>{modifyReason.date}</TableCell>
        <TableCell>{modifyReason.comment}</TableCell>
      </TableRow>
    ))}
  </TableBody>
);

const CancelCommentsAgent = ({ cancelReason = [] }) => (
  <TableBody>
    {cancelReason.map((cancelReason, index) => (
      <TableRow key={`cancel-agent-${index}`}>
        <TableCell>{cancelReason.fullAgentName}</TableCell>
        <TableCell>{cancelReason.commentTime}</TableCell>
        <TableCell>{cancelReason.comment}</TableCell>
      </TableRow>
    ))}
  </TableBody>
);

const CancelCommentsUser = ({ cancelCommentsUser = [] }) => (
  <TableBody>
    {cancelCommentsUser.map((cancelCommentsUser, index) => (
      <TableRow key={`cancel-user-${index}`}>
        <TableCell>{cancelCommentsUser.fullClienttName}</TableCell>
        <TableCell>{cancelCommentsUser.commentTime}</TableCell>
        <TableCell>{cancelCommentsUser.comment}</TableCell>
      </TableRow>
    ))}
  </TableBody>
);
/** Contains the Execution content from the {@link TaskDetails} component */
class TaskExecution extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editable: false,
    };
  }
  LabelText = ({ label, text, containerSx, labelSx, textSx }) => (
    <Grid size={12} sx={containerSx}>
      <Grid container sx={{ gap: 1 }}>
        <Grid size={12}>
          <TextField
            label={label}
            size="small"
            fullWidth
            value={text || ''}
            variant="outlined"
            slotProps={{ input: { readOnly: !this.state.editable } }}
            sx={{ ...textSx }}
          />
        </Grid>
      </Grid>
    </Grid>
  );

  LabelArea = ({ label, text, containerSx, labelSx, textSx }) => (
    <Grid size={12} sx={containerSx}>
      <Grid container sx={{ gap: 1 }}>
        <Grid size={12}>
          <TextField
            label={label}
            size="small"
            fullWidth
            value={text || ''}
            variant="outlined"
            multiline
            minRows={3}
            slotProps={{ input: { readOnly: true } }}
            sx={{ ...textSx }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
  renderTableSection = ({ title, headers, body, height = 180 }) => (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <Scrollbars style={{ height, width: '100%' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={`${header}-${index}`} sx={{ fontWeight: 600 }}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {body}
          </Table>
        </Scrollbars>
      </Paper>
    </Box>
  );
  render() {
    const { lan, taskData, session, showUtcMessage } = this.props;
    const showRouteVariables =
      !RoleUtils.isUserClient(session.user) &&
      Array.isArray(taskData.routeVariables) &&
      taskData.routeVariables.length > 0;
    return (
      <Box >
        {showUtcMessage && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {lan.dateInUTCFormat}
          </Alert>
        )}
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Stack spacing={3}>
              <Grid container spacing={2} alignItems="center">
                <Grid size={{ xs: 12, md: 7 }}>
                  <this.LabelText
                    label={lan.idCustom}
                    text={taskData.number}
                    containerSx={{ m: 0 }}
                    textSx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        fontWeight: 600,
                        fontSize: '1.1rem',
                      },
                    }}
                  />
                </Grid>
                <Grid
                  size={{ xs: 12, md: 5 }}
                  sx={{
                    display: 'flex',
                    justifyContent: { xs: 'flex-start', md: 'flex-start' },
                    alignItems: 'center',
                    pt: 4
                  }}
                >
                  <StatusFormatter {...this.props} value={taskData.status} />
                </Grid>
              </Grid>
              <this.LabelText label={lan.scheduledDate} text={taskData.programmedDate} />
              <this.LabelText label={lan.endDate} text={taskData.endDate} />
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <this.LabelText label={lan.timeExecution} text={taskData.timeExecution} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <this.LabelText label={lan.until} text={taskData.until} />
                </Grid>
              </Grid>
              {!RoleUtils.isUserClient(session.user) && (
                <this.LabelText label={lan.assignedTeam} text={taskData.assignedTeam} />
              )}
              {taskData.duplicateTaskReason && (
                <this.LabelText
                  label={lan.duplicateReason}
                  text={taskData.duplicateTaskReason}
                />
              )}
              <this.LabelArea label={lan.addressTask} text={taskData.address} />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ height: { xs: 320, md: '100%' }, borderRadius: 1, overflow: 'hidden' }}>
              <MapStaticComponent size="500x500">
                {taskData.coords && (
                  <StaticMarker location={taskData.coords} icon={taskData.taskPin} />
                )}
              </MapStaticComponent>
            </Box>
          </Grid>
        </Grid>

        {taskData.taskRejectionReason &&
          taskData.taskRejectionReason.length > 0 &&
          this.renderTableSection({
            title: lan.taskRejectionReason,
            headers: [lan.name, lan.date, lan.dependency, lan.reason, lan.comment],
            body: <RejectComments rejectReason={taskData.taskRejectionReason} />,
          })}

        {taskData.taskPauseReason &&
          taskData.taskPauseReason.length > 0 &&
          this.renderTableSection({
            title: lan.taskPausedReason,
            headers: [lan.name, lan.date, lan.dependency, lan.reason, lan.comment],
            body: <PauseComments pauseReason={taskData.taskPauseReason} />,
          })}

        {taskData.modifyTaskStatusCommentAdmin &&
          taskData.modifyTaskStatusCommentAdmin.length > 0 &&
          this.renderTableSection({
            title: lan.taskStatusModificationCommentByAdministrator,
            headers: [lan.name, lan.date, lan.comment],
            body: (
              <ModifyStatusComments
                modifyReason={taskData.modifyTaskStatusCommentAdmin}
              />
            ),
          })}

        {taskData.modifyTaskStatusCommentManager &&
          taskData.modifyTaskStatusCommentManager.length > 0 &&
          this.renderTableSection({
            title: lan.taskStatusModificationCommentByManager,
            headers: [lan.name, lan.date, lan.comment],
            body: (
              <ModifyStatusComments
                modifyReason={taskData.modifyTaskStatusCommentManager}
              />
            ),
          })}

        {taskData.cancelReason &&
          taskData.cancelReason.length > 0 &&
          this.renderTableSection({
            title: lan.cancelComment,
            headers: [lan.name, lan.date, lan.comment],
            body: <CancelCommentsAgent cancelReason={taskData.cancelReason} />,
          })}

        {taskData.cancelCommentsUser &&
          taskData.cancelCommentsUser.length > 0 &&
          this.renderTableSection({
            title: lan.userCancelComment,
            headers: [lan.name, lan.date, lan.comment],
            body: <CancelCommentsUser cancelCommentsUser={taskData.cancelCommentsUser} />,
          })}

        {taskData.comments && taskData.comments.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              {lan.commentsAgent}
            </Typography>
            <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
              <Scrollbars style={{ height: 180, width: '100%' }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.agentName}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.date}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.countTask}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.comment}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {taskData.comments.map((elem, index) => {
                      if (elem.type === COMMENT_AGENT) {
                        return (
                          <TableRow key={`comment-${index}`}>
                            <TableCell>{elem.userComentName}</TableCell>
                            <TableCell>{elem.commentDate}</TableCell>
                            <TableCell>
                              {`${lan.commentTitle} ${elem.number}`}
                            </TableCell>
                            <TableCell>{elem.comment}</TableCell>
                          </TableRow>
                        );
                      }

                      if (elem.type === RESET_ROUTE_TASK) {
                        return (
                          <TableRow key={`reset-${index}`}>
                            <TableCell>{elem.userComentName}</TableCell>
                            <TableCell>{elem.commentDate}</TableCell>
                            <TableCell>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <Typography component="span">{lan.resetedTask}</Typography>
                                <Box
                                  component="img"
                                  src={DangerIcon}
                                  alt=""
                                  sx={{ width: 16, height: 16 }}
                                />
                              </Stack>
                            </TableCell>
                            <TableCell>{elem.comment}</TableCell>
                          </TableRow>
                        );
                      }

                      return null;
                    })}
                  </TableBody>
                </Table>
              </Scrollbars>
            </Paper>
          </Box>
        )}

        {showRouteVariables && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              {lan.routeTaskVariables.toUpperCase()}
            </Typography>
            <Stack spacing={2}>
              {taskData.routeVariables.map((element, index) => (
                <this.LabelText
                  key={`route-variable-${index}`}
                  label={element.name}
                  text={element.value}
                  textSx={{
                    '& .MuiInputBase-input.Mui-disabled': {
                      fontFamily: 'monospace',
                    },
                  }}
                />
              ))}
            </Stack>
          </Box>
        )}

        {taskData.rescheduleComments && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              {lan.rescheduleComment}
            </Typography>
            <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
              <Scrollbars style={{ height: 140, width: '100%' }}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.name}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.role}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.date}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.comment}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{lan.dateOfRescheduleComment}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{taskData.rescheduleComments.rescheduledUserName}</TableCell>
                      <TableCell>{taskData.rescheduleComments.rescheduleTypeOfUser}</TableCell>
                      <TableCell>{taskData.rescheduleComments.rescheduledDate}</TableCell>
                      <TableCell>{taskData.rescheduleComments.commentReschedule}</TableCell>
                      <TableCell>{taskData.rescheduleComments.dateOfReschedule}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Scrollbars>
            </Paper>
          </Box>
        )}
      </Box>
    );
  }
}
const mapStateToProps = (state) => ({
  session: state.utils.session,
});
export default connect(mapStateToProps)(TaskExecution);
//Original code:
/*import React, { Component } from 'react';
import DangerIcon from '@assets/icons/danger-icon.svg';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import Grid from '@mui/material/Grid2';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';
import StatusFormatter from '../SmartTable/StatusFormatter';
import MapStaticComponent from '~/MapStatic/MapStatic.component';
import StaticMarker from '~/MapStatic/components/StaticMarker';
import { Alert } from '@mui/material';

const COMMENT_AGENT = 0;
const RESET_ROUTE_TASK = 1;
const RejectComments = (props) => {
	const elements = props.rejectReason.map((rejectReason, index) => {
		return (
			<tr key={index + 'rejAgent'}>
				<td key={index + 'rejAgentComment'} className='text-left'>
					{rejectReason.name}
				</td>
				<td key={index + 'rejAgentTime'} className='text-left'>
					{rejectReason.date}
				</td>
				<td key={index + 'rejAgentName'} className='text-left'>
					{rejectReason.dependency}
				</td>
				<td key={index + 'rejAgentName'} className='text-left'>
					{rejectReason.reason}
				</td>
				<td key={index + 'rejAgentName'} className='text-left'>
					{rejectReason.comment}
				</td>
			</tr>
		);
	});
	return <tbody>{elements}</tbody>;
};
const PauseComments = (props) => {
	const elements = props.pauseReason.map((pauseReason, index) => {
		return (
			<tr key={index + 'pauseAgent'}>
				<td key={index + 'ccAgentComment'} className='text-left'>
					{pauseReason.name}
				</td>
				<td key={index + 'pauseAgentComment'} className='text-left'>
					{pauseReason.date}
				</td>
				<td key={index + 'pauseAgentComment'} className='text-left'>
					{pauseReason.dependency}
				</td>
				<td key={index + 'pauseAgentComment'} className='text-left'>
					{pauseReason.reason}
				</td>
				<td key={index + 'pauseAgentTime'} className='text-left'>
					{pauseReason.comment}
				</td>
			</tr>
		);
	});

	return <tbody>{elements}</tbody>;
};
const ModifyStatusComments = (props) => {
	const elements = props.modifyReason.map((modifyReason, index) => {
		return (
			<tr key={index + 'pauseAgent'}>
				<td key={index + 'ccAgentComment'} className='text-left'>
					{modifyReason.name}
				</td>
				<td key={index + 'pauseAgentComment'} className='text-left'>
					{modifyReason.date}
				</td>
				<td key={index + 'pauseAgentTime'} className='text-left'>
					{modifyReason.comment}
				</td>
			</tr>
		);
	});

	return <tbody>{elements}</tbody>;
};
const CancelCommentsAgent = (props) => {
	const elements = props.cancelReason.map((cancelReason, index) => {
		return (
			<tr key={index + 'ccAgent'}>
				<td key={index + 'ccAgentComment'} className='text-left'>
					{cancelReason.fullAgentName}
				</td>
				<td key={index + 'cAgentTime'} className='text-left'>
					{cancelReason.commentTime}
				</td>
				<td key={index + 'cAgentName'} className='text-left'>
					{cancelReason.comment}
				</td>
			</tr>
		);
	});

	return <tbody>{elements}</tbody>;
};
const CancelCommentsUser = (props) => {
	const elements = props.cancelCommentsUser.map((cancelCommentsUser, index) => {
		return (
			<tr key={index + 'cCancelUserComment'}>
				<td key={index + 'ccUserComment'} className='text-left'>
					{cancelCommentsUser.fullClienttName}
				</td>
				<td key={index + 'ccUserTime'} className='text-left'>
					{cancelCommentsUser.commentTime}
				</td>
				<td key={index + 'ccUserFillNmae'} className='text-left'>
					{cancelCommentsUser.comment}

				</td>
			</tr>
		);
	});

	return <tbody>{elements}</tbody>;
};
class TaskExecution extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editable: false,
    };
  }
  LabelText = (props) => {
    const { className, labelClass, textClass, label, text } = props;
    const labelClasses = ['td-label-input', labelClass].filter(Boolean).join(' ');
    const valueClasses = ['td-default-text align-left', textClass].filter(Boolean).join(' ');
    return (
      <Grid size={12} className={className}>
        <Grid container className='my-2'>
          <Grid size={12} className={labelClasses}>
            {label}
          </Grid>
          <Grid size={12} className={valueClasses}>
            <input
              type='text'
              className='task-details-input '
              defaultValue={text}
              disabled={!this.state.editable}
              style={{ width: '100%' }}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };
  LabelArea = (props) => {
    return (
      <Grid size={12} className={props.className}>
        <Grid container className='my-2'>
          <Grid size={12} className={'td-label-input ' + props.labelClass}>{props.label}</Grid>
          <Grid size={12} className={'td-default-text align-left ' + props.textClass}>
						<textarea
              rows='3'
              cols='20'
              className='taskinfo-scrollTextarea task-details-input'
              value={props.text}
              disabled
              style={{ width: '100%' }}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };
  render() {
    return (
      <div className='container'>
        <React.Fragment>
          {this.props.showUtcMessage && (
            <Grid container className='ml-3 pl-2'>
              <Alert severity="warning">{this.props.lan.dateInUTCFormat}</Alert>
            </Grid>
          )}
          <Grid container spacing={2} rowSpacing={0}>
            <Grid size={6}>
              <Grid container>
                <Grid size={7}>
                  <this.LabelText
                    label={this.props.lan.idCustom}
                    text={this.props.taskData.number}
                    className='my-3'
                    textClass='td-task-number'
                  />
                </Grid>
                <Grid size={'auto'} className='my-auto'>
                  <StatusFormatter {...this.props} value={this.props.taskData.status} />
                </Grid>
              </Grid>
              <this.LabelText
                label={this.props.lan.scheduledDate}
                text={this.props.taskData.programmedDate}
                className='my-3'
              />
              <this.LabelText label={this.props.lan.endDate} text={this.props.taskData.endDate} className='my-3' />
              <div className='row'>
                <div className='col'>
                  <this.LabelText
                    label={this.props.lan.timeExecution}
                    text={this.props.taskData.timeExecution}
                    className='my-3'
                  />
                </div>
                <div className='col'>
                  <this.LabelText label={this.props.lan.until} text={this.props.taskData.until} className='my-3' />
                </div>
              </div>
              {!RoleUtils.isUserClient(this.props.session.user) ? (
                <this.LabelText
                  label={this.props.lan.assignedTeam}
                  text={this.props.taskData.assignedTeam}
                  className='my-3'
                />
              ) : null}
              { this.props.taskData.duplicateTaskReason && (
                <this.LabelText
                  label={this.props.lan.duplicateReason}
                  text={this.props.taskData.duplicateTaskReason}
                  className='my-3'
                />
              )}
              <this.LabelArea
                label={this.props.lan.addressTask}
                text={this.props.taskData.address}
                className='my-3'
              />
            </Grid>
            <Grid size={6}>
              <div style={{ height: '80%' }}>
                <MapStaticComponent size='500x500'>
                  {this.props.taskData.coords && (
                    <StaticMarker location={this.props.taskData.coords} icon={this.props.taskData.taskPin} />
                  )}
                </MapStaticComponent>
              </div>
            </Grid>
          </Grid>
          {this.props.taskData.taskRejectionReason && this.props.taskData.taskRejectionReason.length > 0 && (
            <Scrollbars className='mt-2' style={{ height: '180px', width: '100%' }}>
              <React.Fragment>
                <div className='row ml-3 mt-2'>
                  <Grid container className={'td-label-input ' + this.props.lan.taskRejectionReason}>
                    {this.props.lan.taskRejectionReason}
                  </Grid>
                </div>
                <div className='row mt-4'>
                  <div className='col ml-4'>
                    <div className='AgentCancel-comments-table'>
                      <Scrollbars style={{ height: '180px', width: '100%' }}>
                        <div className='table-responsive-sm'>
                          <table className='table table-sm table-hover'>
                            <thead>
                            <tr>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.name}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.date}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.dependency}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.reason}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.comment}
                              </th>
                            </tr>
                            </thead>
                            <RejectComments rejectReason={this.props.taskData.taskRejectionReason} />
                          </table>
                        </div>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            </Scrollbars>
          )}
          {this.props.taskData.taskPauseReason && this.props.taskData.taskPauseReason.length > 0 && (
            <Scrollbars className='mt-2' style={{ height: '180px', width: '100%' }}>
              <React.Fragment>
                <div className='row ml-3 mt-2'>
                  <Grid container className={'td-label-input ' + this.props.lan.taskPausedReason}>
                    {this.props.lan.taskPausedReason}
                  </Grid>
                </div>
                <div className='row mt-4'>
                  <div className='col ml-4'>
                    <div className='AgentCancel-comments-table'>
                      <Scrollbars style={{ height: '180px', width: '100%' }}>
                        <div className='table-responsive-sm'>
                          <table className='table table-sm table-hover'>
                            <thead>
                            <tr>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.name}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.date}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.dependency}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.reason}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.comment}
                              </th>
                            </tr>
                            </thead>
                            <PauseComments pauseReason={this.props.taskData.taskPauseReason} />
                          </table>
                        </div>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            </Scrollbars>
          )}
          {this.props.taskData.modifyTaskStatusCommentAdmin &&
            this.props.taskData.modifyTaskStatusCommentAdmin.length > 0 && (
              <Scrollbars className='mt-2' style={{ height: '180px', width: '100%' }}>
                <React.Fragment>
                  <div className='row ml-3 mt-2'>
                    <Grid container className={'td-label-input ' + this.props.lan.taskPausedReason}>
                      {this.props.lan.taskStatusModificationCommentByAdministrator}
                    </Grid>
                  </div>
                  <div className='row mt-4'>
                    <div className='col ml-4'>
                      <div className='AgentCancel-comments-table'>
                        <Scrollbars style={{ height: '180px', width: '100%' }}>
                          <div className='table-responsive-sm'>
                            <table className='table table-sm table-hover'>
                              <thead>
                              <tr>
                                <th scope='col-auto' style={{ textAlign: 'left' }}>
                                  {this.props.lan.name}
                                </th>
                                <th scope='col-auto' style={{ textAlign: 'left' }}>
                                  {this.props.lan.date}
                                </th>
                                <th scope='col-auto' style={{ textAlign: 'left' }}>
                                  {this.props.lan.comment}
                                </th>
                              </tr>
                              </thead>
                              <ModifyStatusComments modifyReason={this.props.taskData.modifyTaskStatusCommentAdmin} />
                            </table>
                          </div>
                        </Scrollbars>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              </Scrollbars>
            )}
          {this.props.taskData.modifyTaskStatusCommentManager &&
            this.props.taskData.modifyTaskStatusCommentManager.length > 0 && (
              <Scrollbars className='mt-2' style={{ height: '180px', width: '100%' }}>
                <React.Fragment>
                  <div className='row ml-3 mt-2'>
                    <Grid container className={'td-label-input ' + this.props.lan.taskPausedReason}>
                      {this.props.lan.taskStatusModificationCommentByManager}
                    </Grid>
                  </div>
                  <div className='row mt-4'>
                    <div className='col ml-4'>
                      <div className='AgentCancel-comments-table'>
                        <Scrollbars style={{ height: '180px', width: '100%' }}>
                          <div className='table-responsive-sm'>
                            <table className='table table-sm table-hover'>
                              <thead>
                              <tr>
                                <th scope='col-auto' style={{ textAlign: 'left' }}>
                                  {this.props.lan.name}
                                </th>
                                <th scope='col-auto' style={{ textAlign: 'left' }}>
                                  {this.props.lan.date}
                                </th>
                                <th scope='col-auto' style={{ textAlign: 'left' }}>
                                  {this.props.lan.comment}
                                </th>
                              </tr>
                              </thead>
                              <ModifyStatusComments modifyReason={this.props.taskData.modifyTaskStatusCommentManager} />
                            </table>
                          </div>
                        </Scrollbars>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              </Scrollbars>
            )}
          {this.props.taskData.cancelReason && this.props.taskData.cancelReason.length > 0 && (
            <Scrollbars className='mt-2' style={{ height: '180px', width: '100%' }}>
              <React.Fragment>
                <div className='row ml-3 mt-2'>
                  <Grid container className={'td-label-input ' + this.props.lan.commentsAgent}>{this.props.lan.cancelComment}</Grid>
                </div>
                <div className='row mt-4'>
                  <div className='col ml-4'>
                    <div className='AgentCancel-comments-table'>
                      <Scrollbars style={{ height: '180px', width: '100%' }}>
                        <div className='table-responsive-sm'>
                          <table className='table table-sm table-hover'>
                            <thead>
                            <tr>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.name}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.date}
                              </th>
                              <th scope='col-auto' style={{ textAlign: 'left' }}>
                                {this.props.lan.comment}
                              </th>
                            </tr>
                            </thead>
                            <CancelCommentsAgent cancelReason={this.props.taskData.cancelReason} />
                          </table>
                        </div>
                      </Scrollbars>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            </Scrollbars>
          )}
          {this.props.taskData.cancelCommentsUser && this.props.taskData.cancelCommentsUser.length > 0 && (
            <React.Fragment>
              <div className='row ml-3 mt-2'>
                <Grid container className={'td-label-input ' + this.props.lan.commentsUser}>
                  {this.props.lan.userCancelComment}
                </Grid>
              </div>
              <div className='row mt-4'>
                <div className='col ml-4'>
                  <div className='AgentCancel-comments-table'>
                    <Scrollbars style={{ height: '180px', width: '100%' }}>
                      <div className='table-responsive-sm'>
                        <table className='table table-sm table-hover'>
                          <thead>
                          <tr>
                            <th scope='col-auto' style={{ textAlign: 'left' }}>
                              {this.props.lan.name}
                            </th>
                            <th scope='col-auto' style={{ textAlign: 'left' }}>
                              {this.props.lan.date}
                            </th>
                            <th scope='col-auto' style={{ textAlign: 'left' }}>
                              {this.props.lan.comment}
                            </th>
                          </tr>
                          </thead>
                          <CancelCommentsUser cancelCommentsUser={this.props.taskData.cancelCommentsUser} />
                        </table>
                      </div>
                    </Scrollbars>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          <Scrollbars style={{ height: '180px', width: '100%' }}>
            <Grid container className='ml-2 mx-2'>
              {this.props.taskData.comments && this.props.taskData.comments.length > 0 && (
                <div className='col no-padding'>
                  <Grid container className='my-2 ml-1'>
                    <Grid size={12} className={'td-label-input ' + this.props.lan.commentsAgent}>
                      {this.props.lan.commentsAgent}
                    </Grid>
                  </Grid>
                  <Scrollbars className='ml-3' style={{ height: '180px' }}>
                    <div className='table-responsive-sm mr-4 pr-2'>
                      <table className='table table-sm table-hover '>
                        <thead>
                        <tr>
                          <th scope='col-auto' style={{ textAlign: 'left' }}>
                            {this.props.lan.agentName}
                          </th>
                          <th scope='col-auto' style={{ textAlign: 'left' }}>
                            {this.props.lan.date}
                          </th>
                          <th scope='col-auto' style={{ textAlign: 'left' }}>
                            {this.props.lan.countTask}
                          </th>
                          <th scope='col-auto' style={{ textAlign: 'left' }}>
                            {this.props.lan.comment}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.taskData.comments.map((elem, index) => {
                          return (
                            <React.Fragment>
                              {elem.type === COMMENT_AGENT && (
                                <tr key={index + 'acoments'}>
                                  <td key={index + 'auserName'} className='text-left'>
                                    {elem.userComentName}
                                  </td>
                                  <td key={index + 'aDate'} className='text-left'>
                                    {elem.commentDate}
                                  </td>
                                  <td key={index + 'anumb'} className='text-left'>
                                    {this.props.lan.commentTitle + ' ' + elem.number}
                                  </td>
                                  <td key={index + 'acomment'} className='text-left'>
                                    {elem.comment}
                                  </td>
                                </tr>

                              )}
                              {elem.type === RESET_ROUTE_TASK && (
                                <tr key={index + 'crComments'}>
                                  <td key={index + 'crUserName'} className='text-left'>
                                    {elem.userComentName}
                                  </td>
                                  <td key={index + 'crDate'} className='text-left'>
                                    {elem.commentDate}
                                  </td>
                                  <td key={index + 'crReset'} className='text-left'>
                                    {this.props.lan.resetedTask}{' '}
                                    <img className='imageSize-danger-icon' src={DangerIcon} alt='' />{' '}
                                  </td>
                                  <td key={index + 'crComent'} className='text-left'>
                                    {elem.comment}
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                        </tbody>
                      </table>
                    </div>
                  </Scrollbars>
                </div>
              )}
              {!RoleUtils.isUserClient(this.props.session.user) &&
                this.props.taskData.routeVariables != null &&
                this.props.taskData.routeVariables.length > 0 && (
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Grid container>
                      <Grid size={12} className='mt-2'>
                        <span className='text-left'>{this.props.lan.routeTaskVariables.toUpperCase()}</span>
                      </Grid>
                    </Grid>
                    {this.props.taskData.routeVariables.map((element, index) => (
                      <Grid container>
                        <this.LabelText
                          label={element.name}
                          text={element.value}
                          className='my-3'
                          textClass='td-route-variable'
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}
            </Grid>
          </Scrollbars>
          <Grid container className='ml-2 mx-2'>
            {this.props.taskData.rescheduleComments && (
              <div className='col no-padding'>
                <Grid className='my-2 ml-1'>
                  <Grid size={12} className={'td-label-input ' + this.props.lan.rescheduleComment}>
                    {this.props.lan.rescheduleComment}
                  </Grid>
                </Grid>
                <div className='table-responsive-sm mr-4 pr-2'>
                  <table className='table table-sm table-hover '>
                    <thead>
                    <tr>
                      <th scope='col-auto' style={{ textAlign: 'left' }}>
                        {this.props.lan.name}
                      </th>
                      <th scope='col-auto' style={{ textAlign: 'left' }}>
                        {this.props.lan.role}
                      </th>
                      <th scope='col-auto' style={{ textAlign: 'left' }}>
                        {this.props.lan.date}
                      </th>
                      <th scope='col-auto' style={{ textAlign: 'left' }}>
                        {this.props.lan.comment}
                      </th>
                      <th scope='col-auto' style={{ textAlign: 'left' }}>
                        {this.props.lan.dateOfRescheduleComment}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr key={'racoments'}>
                      <td key={ 'rauserName'} className='text-left'>
                        {this.props.taskData.rescheduleComments.rescheduledUserName}
                      </td>
                      <td key={ 'rauserName'} className='text-left'>
                        {this.props.taskData.rescheduleComments.rescheduleTypeOfUser}
                      </td>
                      <td key={'rauserName'} className='text-left'>
                        {this.props.taskData.rescheduleComments.rescheduledDate}
                      </td>
                      <td key={'raDate'} className='text-left'>
                        {this.props.taskData.rescheduleComments.commentReschedule}
                      </td>
                      <td key={'racomment'} className='text-left'>
                        {this.props.taskData.rescheduleComments.dateOfReschedule}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </Grid>
        </React.Fragment>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  session: state.utils.session,
});
export default connect(mapStateToProps)(TaskExecution);
*/
